import React from 'react';
import Icon from '../../../components/AppIcon';

const PipelineVisualization = () => {
  const pipelineStages = [
    {
      id: 1,
      name: 'Applications',
      count: 247,
      color: 'bg-blue-500',
      icon: 'FileText',
      percentage: 100
    },
    {
      id: 2,
      name: 'AI Screening',
      count: 189,
      color: 'bg-purple-500',
      icon: 'Brain',
      percentage: 76.5
    },
    {
      id: 3,
      name: 'HR Review',
      count: 142,
      color: 'bg-orange-500',
      icon: 'Eye',
      percentage: 57.5
    },
    {
      id: 4,
      name: 'Interview',
      count: 89,
      color: 'bg-green-500',
      icon: 'Calendar',
      percentage: 36.0
    },
    {
      id: 5,
      name: 'Final Round',
      count: 34,
      color: 'bg-indigo-500',
      icon: 'Users',
      percentage: 13.8
    },
    {
      id: 6,
      name: 'Hired',
      count: 12,
      color: 'bg-emerald-500',
      icon: 'CheckCircle',
      percentage: 4.9
    }
  ];

  const recentCandidates = [
    {
      id: 1,
      name: 'Sarah Johnson',
      position: 'Software Engineer',
      stage: 'Interview',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
      score: 92
    },
    {
      id: 2,
      name: 'Michael Chen',
      position: 'Data Analyst',
      stage: 'HR Review',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
      score: 85
    },
    {
      id: 3,
      name: 'Emma Davis',
      position: 'UX Designer',
      stage: 'Final Round',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
      score: 88
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 card-elevation-base">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recruitment Pipeline</h3>
        <button className="text-sm text-primary hover:text-primary/80 font-medium transition-colors">
          View Details
        </button>
      </div>
      {/* Pipeline Stages */}
      <div className="space-y-4 mb-8">
        {pipelineStages?.map((stage, index) => (
          <div key={stage?.id} className="relative">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-3">
                <div className={`w-8 h-8 ${stage?.color} rounded-full flex items-center justify-center`}>
                  <Icon name={stage?.icon} size={16} color="white" />
                </div>
                <span className="text-sm font-medium text-foreground">{stage?.name}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-muted-foreground">{stage?.percentage}%</span>
                <span className="text-sm font-semibold text-foreground">{stage?.count}</span>
              </div>
            </div>
            
            <div className="ml-11">
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`${stage?.color} h-2 rounded-full transition-all duration-500`}
                  style={{ width: `${stage?.percentage}%` }}
                ></div>
              </div>
            </div>

            {/* Connection Line */}
            {index < pipelineStages?.length - 1 && (
              <div className="absolute left-4 top-10 w-0.5 h-6 bg-border"></div>
            )}
          </div>
        ))}
      </div>
      {/* Recent Candidates */}
      <div className="border-t border-border pt-6">
        <h4 className="text-sm font-semibold text-foreground mb-4">Recent Candidates</h4>
        <div className="space-y-3">
          {recentCandidates?.map((candidate) => (
            <div key={candidate?.id} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <img 
                  src={candidate?.avatar} 
                  alt={candidate?.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{candidate?.name}</p>
                <p className="text-xs text-muted-foreground">{candidate?.position}</p>
              </div>
              <div className="flex items-center space-x-2">
                <div className="text-xs px-2 py-1 bg-primary/10 text-primary rounded-full">
                  {candidate?.stage}
                </div>
                <div className="text-xs font-medium text-success">
                  {candidate?.score}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PipelineVisualization;